import { DropProductRequestObject } from "./DeleteRequestObjects/DropProductRequestObject";
import { CancelProductRequestObject } from "./DeleteRequestObjects/CancelProductRequestObject";
import { DropWithFabricLiabilityRequestObject } from "./DeleteRequestObjects/DropWithFabricLiabilityRequestObject";
import { DropWithoutFabricLiabilityRequestObject } from "./DeleteRequestObjects/DropWithoutFabricLiabilityRequestObject";


export const DeleteRequestFactory = (deleteType = 'drop', remark, fabricLiabilityStatus) => {
    console.log(deleteType, remark, "Delete Request handler");
    if (deleteType === 'drop') {
        return new DropProductRequestObject(remark, fabricLiabilityStatus);
    } else if (deleteType === 'cancel') {
        return new CancelProductRequestObject(remark, fabricLiabilityStatus);
        // } else if (deleteType === 'delete') {
        //     new SoftDeleteProductRequestObject(remark);
    } else if (deleteType === 'with-fabric-liability') {
        return new DropWithFabricLiabilityRequestObject(remark);
    } else if (deleteType === 'without-fabric-liability') {
        return new DropWithoutFabricLiabilityRequestObject(remark);
    } else if (deleteType === 'others') {
        return new DropProductRequestObject(remark);
    }
}